document.addEventListener('DOMContentLoaded', () => {
  const popup = document.getElementById('bb-popup');
  if (!popup) return;

  const closeBtn = popup.querySelector('.bb-close');
  const addToCartBtn = document.getElementById('bb-add-to-cart');
  const categoryEls = document.querySelectorAll('.bb-category');
  let selectedProducts = [];
  const maxSlots = 3;

  const priceEl = document.getElementById('bb-total-price');
  let totalPrice = 0;

  const formatPrice = (paise) => `₹${(paise / 100).toFixed(0)}`;

  const updatePriceUI = () => {
    priceEl.textContent = formatPrice(totalPrice);
  };

  const getSlotHTML = (slotIndex, image, title) => {
    if (!image) {
      return `<div class="empty-slot"></div>`;
    }

    if (slotIndex === 1) {
      return `
        <div class="slot-img-wrapper">
          <img src="${image}" alt="" loading="lazy" fetchpriority="low">
        </div>
        <p class="slot-title">${title}</p>
      `;
    }

    return `
      <button class="slot-remove">&times;</button>
      <div class="slot-img-wrapper">
        <img src="${image}" alt="" loading="lazy" fetchpriority="low">
      </div>
      <p class="slot-title">${title}</p>
    `;
  };

  const attachRemoveEvents = () => {
    document.querySelectorAll('.slot-remove').forEach((btn) => {
      btn.onclick = (e) => {
        const slot = e.target.closest('.bb-slot');
        const index = Number(slot.dataset.slot) - 1;

        const removed = selectedProducts.splice(index, 1)[0];
        if (removed?.price) {
          totalPrice -= removed.price;
          updatePriceUI();
        }
        refreshSlots();
      };
    });
  };

  const fillSlot = (slotIndex, image, title) => {
    const slot = document.querySelector(`.bb-slot[data-slot="${slotIndex}"]`);
    if (!slot) return;

    slot.classList.add('filled');
    slot.innerHTML = getSlotHTML(slotIndex, image, title);

    slot.dataset.img = image || '';
    slot.dataset.title = title || '';

    if (slotIndex > 1) attachRemoveEvents();
  };

  const refreshSlots = () => {
    document.querySelectorAll('.bb-slot').forEach((slot) => {
      const idx = Number(slot.dataset.slot);
      slot.classList.remove('filled');
      slot.innerHTML = getSlotHTML(idx, null, null);
      slot.removeAttribute('data-img');
      slot.removeAttribute('data-title');
    });

    selectedProducts.forEach((item, index) => {
      fillSlot(index + 1, item.img, item.title);
    });

    addToCartBtn.disabled = selectedProducts.length !== maxSlots;
    totalPrice = selectedProducts.reduce((sum, item) => sum + (item.price || 0), 0);
    updatePriceUI();
  };

  const addProduct = (variantId, image, title, price) => {
    if (!variantId) return;
    if (selectedProducts.length >= maxSlots) {
      alert('Maximum items selected');
      return;
    }

    selectedProducts.push({
      id: variantId,
      img: image,
      title,
      price: Number(price),
    });

    totalPrice += Number(price);
    updatePriceUI();

    fillSlot(selectedProducts.length, image, title);
    addToCartBtn.disabled = selectedProducts.length !== maxSlots;
  };

  categoryEls.forEach((cat) => {
    cat.addEventListener('click', () => {
      const { variantId: vid, img, title, price } = cat.dataset;

      selectedProducts = [];
      totalPrice = 0;
      updatePriceUI();
      refreshSlots();

      addProduct(vid, img, title, price);

      popup.classList.add('is-open');
    });
  });

  document.querySelectorAll('.bb-add-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const { id, img, title, price } = btn.dataset;
      addProduct(id, img, title, price);
    });
  });

  closeBtn.addEventListener('click', () => popup.classList.remove('is-open'));
  popup.addEventListener('click', (e) => {
    if (e.target === popup) popup.classList.remove('is-open');
  });

  addToCartBtn.addEventListener('click', async () => {
    if (selectedProducts.length === 0) return;

    addToCartBtn.textContent = 'Adding...';
    addToCartBtn.disabled = true;

    try {
      for (const item of selectedProducts) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(item.id), quantity: 1 }),
        });
      }

      sessionStorage.setItem('openDrawerAfterReload', 'true');

      location.reload();
    } catch (err) {
      console.error(err);
      addToCartBtn.textContent = 'Add To Bag';
      addToCartBtn.disabled = false;
    }
  });

  if (sessionStorage.getItem('openDrawerAfterReload') === 'true') {
    sessionStorage.removeItem('openDrawerAfterReload');

    setTimeout(() => {
      const drawer = document.querySelector('.drawer--cart');

      if (drawer) {
        drawer.classList.add('is-open');
      } else {
        console.warn('Drawer not found: .drawer--cart');
      }
    }, 300);
  }
});
